import { render } from "./TheNavigation.vue?vue&type=template&id=3e5ff454&ts=true"
import script from "./TheNavigation.vue?vue&type=script&lang=ts"
export * from "./TheNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src87568447/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__